import React, { useContext, useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import ModalSubscribe from "./ModalSubscribe";
import Placeholder from 'react-bootstrap/Placeholder';
import parse from "html-react-parser";


const LeftColomn = (props) => {
  const [htmlFileString, setHtmlFileString] = useState();
  const [jsonConfig, setJsonConfig] = useState();


  async function fetchHtml() {
    setHtmlFileString(await (await fetch(`/staticData/updateContent.html`)).text())
  }

  async function fetchConfig() {
    setJsonConfig(
      await (await fetch(`/staticData/GeneralConfig.json`)).json()
    );
  };

    useEffect(() => {
      fetchHtml();
      fetchConfig();
    }, []);


  return (
    <Container>
      <Card className="text-center">
        <Card.Body>
          {/* <Card.Title>{genConfig.updateTitle}</Card.Title> */}
          {/* <Card.Title>{jsonConfig && jsonConfig.updateTitle}</Card.Title> */}
          {jsonConfig ? <Card.Title>{jsonConfig.updateTitle}</Card.Title> : <Placeholder as={Card.Title} animation="glow"><Placeholder xs={6} /></Placeholder>}
          <div>
            {htmlFileString ? parse(htmlFileString) 
            : 
            // <p><strong>LOADING... Please wait</strong></p>
            <Placeholder as={Card.Text} animation="glow">
            <Placeholder xs={7} /> <Placeholder xs={4} /> <Placeholder xs={4} />{' '}
            <Placeholder xs={6} /> <Placeholder xs={8} />
          </Placeholder>
            }
          </div>
        </Card.Body>
      </Card>
      <Card className="text-center" border="light">
        <Card.Body>
          <Card.Text>
            Are you a member? Consider subscribing to our mailing list!
          </Card.Text>
          <ModalSubscribe />
        </Card.Body>
      </Card>
    </Container>
  );
};

export default LeftColomn;
